import PubSub from "pubsub-js";

import clipboardActions from "../../constants/clipboardActions";
import pasteDataTypes from "../../constants/pasteDataTypes";
import PubSubTopics from "../../constants/pubSubTopics";
import dialogs from "../../dialogs";
import { isNativeCommsInstalled, nativeCommsBroadcastMessageTypes } from "../../nativeComms";
import isEditable from "../../utils/isEditable";

const handleClipboardWrite = (nativeMsg, execCmd) => {
  // If we have a native interface, just route everything through that
  // so we get standard browser events
  if (isNativeCommsInstalled()) {
    // But first, we must warn the world that the paste event is coming
    // so that the appropriate cell can prepare for it
    PubSub.publishSync(PubSubTopics.clipboardEventPending, null);
    // Now send it through to native
    PubSub.publish(PubSubTopics.sendNativeMessage, {
      msg: nativeMsg
    });
    return;
  }

  // For now, just triggering the native browser's cut and copy are
  // sufficient for our needs.
  // But we need to alert the listening views to shift focus to a text field
  // first so they are able to respond to the command correctly
  PubSub.publishSync(PubSubTopics.clipboardEventPending, null);
  document.execCommand(execCmd);

  // This code is not required, but as a backup, this code would write
  // to the clipboard using the navigator.clipboardAPI (sadly plain text only,
  // which is why we favour the above)

  // if (!isEditable(document.activeElement)) {
  //   // In the longer term, this would allow us to write multiple data formats
  //   // from within the browser. But support does not exist yet.

  //   // let dataTransfer = new DataTransfer();
  //   // const setData = (t, d) => {
  //   //   dataTransfer.items.add(t, d);
  //   // };
  //   // const writeToClipboard = () => navigator.clipboard.write(dataTransfer);
  //   // const clipboardData = {
  //   //   setData,
  //   //   writeToClipboard
  //   // };

  //   // Instead, we will just write out plaintext
  //   const clipboardData = {
  //     setData: (t, d) => (t === pasteDataTypes.PLAINTEXT ? navigator.clipboard.writeText(d) : null)
  //   };
  //   PubSub.publishSync(pubSubMsg, clipboardData);
  // } else {
  //   dialogs.alertPrompt(`Please use the shortcut ${shortcut} to ${opLabel} text fields`);
  // }
};

const handleCut = () => {
  handleClipboardWrite(nativeCommsBroadcastMessageTypes.EDIT_CUT, "cut");
};

const handleCopy = () => {
  handleClipboardWrite(nativeCommsBroadcastMessageTypes.EDIT_COPY, "copy");
};

const handlePaste = () => {
  // If we have a native interface, just route everything through that
  // so we get standard browser events
  if (isNativeCommsInstalled()) {
    // But first, we must warn the world that the paste event is coming
    // so that the appropriate cell can prepare for it
    PubSub.publishSync(PubSubTopics.clipboardEventPending, null);
    // Now send it through to native
    PubSub.publish(PubSubTopics.sendNativeMessage, {
      msg: nativeCommsBroadcastMessageTypes.EDIT_PASTE
    });
    return;
  }

  // Otherwise, we need to handle it entirely within the browser

  // This does not work in Chrome.
  // It may work when served over https, so consider for later
  // document.execCommand("paste");

  // For now, we are instead going to use the navigator.clipboard API
  // This is not ideal, as it is plaintext only so we lose our good types
  // Keep an eye on when full support is added for multiple data types again

  if (!isEditable(document.activeElement) && navigator.clipboard && navigator.clipboard.readText) {
    navigator.clipboard.readText().then(textData => {
      const types = [pasteDataTypes.PLAINTEXT];
      const getData = t => (t === pasteDataTypes.PLAINTEXT ? textData : null);
      const clipboardData = {
        types,
        getData
      };
      PubSub.publishSync(PubSubTopics.paste, clipboardData);
    });
  } else {
    dialogs.alertPrompt("Please use the shortcut Ctrl+V to paste into text fields");
  }
};

export default action => {
  switch (action) {
    case clipboardActions.CUT:
      handleCut();
      return;
    case clipboardActions.COPY:
      handleCopy();
      return;
    case clipboardActions.PASTE:
      handlePaste();
      return;
  }
};
